export const RightStoreProductSubscriptionType = {
    LimitedSubscription: "digital-subscription-vessel-custom",
    FullSubscription: "platform-subscription",
    PSCRiskIQInApp: "psc-riskIQ-inapp",
}